module.exports = __webpack_public_path__ + "static/User-7632257eb0faf2406fe9813a4eb2a274.jpeg";